import { MyBusinessSchema } from '../../data/types';
import { capitalizeString } from '../../utils/helpers';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FlagIcon from '@mui/icons-material/Flag';
// import { ReactComponent as DeleteIcon } from '../icons/DeleteIcon.svg';

interface BusinessCardProps {
  business: MyBusinessSchema;
  onEdit?: (business: MyBusinessSchema) => void;
  onDelete?: (business: MyBusinessSchema) => void;
}

const BusinessCard = ({ business, onEdit, onDelete }: BusinessCardProps) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-lg p-5 transition-all duration-300 relative group border border-gray-100">
      {/* Action buttons - appear on hover */}
      <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300 z-10">
        {onEdit && (
          <button
            onClick={() => onEdit(business)}
            className="border-0 p-1.5 rounded-lg bg-white/90 backdrop-blur-sm hover:bg-primaryDark-400/10 transition-all duration-200"
            aria-label="Edit business"
          >
            <EditIcon className="w-2 h-2 text-primaryDark-400 hover:text-primaryDark-100 transition-colors" />
          </button>
        )}
        {onDelete && (
          <button
            onClick={() => onDelete(business)}
            className="border-0 p-1.5 rounded-lg bg-white/90 backdrop-blur-sm hover:bg-red-50 transition-all duration-200"
            aria-label="Delete business"
          >
            <DeleteIcon className="w-4 h-4 text-red-400 hover:text-red-600 transition-colors" />
          </button>
        )}
      </div>

      {/* Business content */}
      <div className="space-y-4">
        <div>
          <h3 className="text-xl font-semibold text-primaryDark-100 mb-1">
            {business.business_name}
          </h3>
          <div className="flex items-center">
            <div className="w-1 h-4 bg-primaryDark-300 rounded-full mr-2"></div>
            <p className="text-primaryDark-400 text-sm">
              {business.business_category}
            </p>
          </div>
        </div>
        
        <div className="space-y-3.5 mt-2">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primaryDark-400/20">
              <StorefrontIcon className="w-4 h-4 text-primaryDark-100/70" />
            </div>
            <div className="flex items-center">
              <span className="text-sm text-gray-400">{business.business_type}</span>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primaryDark-400/20">
              <LocationOnIcon className="w-4 h-4 text-primaryDark-100/70" />
            </div>
            <div className="flex items-center">
              <span className="text-sm text-gray-400">{capitalizeString(business.cooking_county)}, {capitalizeString(business.cooking_state)}</span>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primaryDark-400/20">
              <FlagIcon className="w-4 h-4 text-primaryDark-100/70" />
            </div>
            <div className="flex items-center">
              <span className="text-sm font-semibold text-gray-500">{capitalizeString(business.business_stage)} Stage</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCard; 